import React, { useEffect, useRef, useState } from "react";
import Stage from "./Stage/Stage";
import classes from "./CurveNameForm.module.css";

import gsap from "gsap";

import StageSeats from "./data/StageSeats";
import CurveNameInfo from "./CurveNameInfo/CurveNameInfo";
import Stepper from "./Stepper/Stepper";
import Button from "../../../UI/Button/Button";
import InfoForm from "./InfoForm.js/InfoForm";

const CurveNameForm = (props) => {
  const stage = useRef(null);
  const [step, setStep] = useState(1);
  const [seat, setSeat] = useState(null);

  let JSX = <CurveNameInfo />;

  if (step === 1) {
    JSX = <CurveNameInfo />;
  } else if (step === 2) {
    JSX = <Stage data={StageSeats} setSeat={setSeat} />;
  } else if (step === 3) {
    JSX = <InfoForm selected = {seat} />;
  }else if (step === 4) {
    JSX = <h1>TODO: LOADING TILL MSG CONFIRMED</h1>;
  }

  const nextStep = () => {
    if (step < 4) {
      setStep(step + 1);
    }
  };
  const prevStep = () => {
    if(step === 3){
      setSeat(null)
    }
    if(step === 2){
      setSeat(null)
    }
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.stages}>
        <Stepper step={step} />
        <div className={classes.stage} ref={stage}>
          {JSX}
          {step == 2 && (
            <div className={classes.prices}>
              <div className={classes.goldPrice}>3000$</div>
              <div className={classes.silverPrice}>1500$</div>
            </div>
          )}
        </div>
      </div>
      {/* {<Stage data={StageSeats} />} */}
      <div className={classes.actions}>
        {(step != 1 && step != 4) && (
          <Button className={classes.btn} onClick={prevStep}>
            Back
          </Button>
        )}
        {step != 4 &&
          ((step == 2 && seat === null) ? (
            <Button className={classes.btn+" "+classes.inActive} onClick={nextStep} backgroundColor={"#476078"}>
              Next
            </Button>
          ) : (
            <Button className={classes.btn} onClick={nextStep} backgroundColor={"#014480"}>
              Next
            </Button>
          ))}
      </div>
    </div>
  );
};
export default CurveNameForm;
